import { ISorter } from "@/models/tables";
import i18n from "@/i18n";

const configurationsSorters: ISorter[] = [
  {
    field: "name",
    label: i18n.t("_.name").toString()
  },
  {
    field: "enabled",
    label: i18n.t("_.status").toString()
  }
];

const categoriesSorters: ISorter[] = [
  {
    field: "name",
    label: i18n.t("_.name").toString()
  },
  {
    field: "enabled",
    label: i18n.t("_.status").toString()
  }
];

export { configurationsSorters, categoriesSorters };
